import {makeStyles, Theme} from '@material-ui/core';
import React from 'react';
import {Edit,  required, SimpleForm, TextInput, Toolbar, SaveButton, DeleteButton, ReferenceInput, SelectInput} from 'react-admin';
import {IP_LISTS, FIXED_COLUMN_CATEGORY, IP_LIST_TYPE} from '../../consts/Names';
import {useParams} from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },

   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));

const EditToolbar = (props) => (
   <Toolbar {...props}  className={props.className}>
      <SaveButton submitOnEnter={false} variant="text" />
      {props.record.name !== FIXED_COLUMN_CATEGORY && <DeleteButton  undoable={false}/>}      
   </Toolbar>
);

export const IpListEdit = (props) => {
   const {theme} = props;
   let basePath
   if (typeof props.basePath === 'undefined') {
      basePath = '';
   } else {
      basePath = props.basePath
   }
   const {id} = useParams()
   const classes = useStyles(theme);
   let ids = !props.id ? id : props.id
   return (<Edit {...props}  id={ids} basePath={basePath} undoable={false} title="Edit currency" >
      <SimpleForm toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>

         <TextInput className={classes.textFld} label="IP" source={IP_LISTS.ip} />
         <TextInput className={classes.textFld} label="Description" source={IP_LISTS.description} />
         <SelectInput label="List Type" source={IP_LISTS.list_type} validate={[required()]} choices={IP_LIST_TYPE} />

      </SimpleForm>
   </Edit>
)
}